import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header";
import CategoryNav from "./components/CategoryNav";
import CarpetDetails from "./pages/purchase/carpet-cleaning/CarpetDetails";
import AddressDetails from "./pages/purchase/carpet-cleaning/AddressDetails";
import Payment from "./pages/purchase/carpet-cleaning/Payment";
import LoginPage from "./pages/auth/login";
import RegisterPage from "./pages/auth/register";
import CategoryPage from "./pages/category";
import ProductDetail from "./pages/product-detail";
import "./App.css";
import HomePage from "./pages/home";
import ProtectedRoute from "./components/ProtectedRoute";
import PaymentSuccess from "./pages/purchase/carpet-cleaning/PaymentSuccess";
import ProfilePage from "./pages/profile";
import OrdersPage from "./pages/orders";
import AddressesPage from "./pages/addresses";
import DealerProductsPage from "./pages/dealer-products";
import CartPage from "./pages/cart";
import { LocationProvider } from "./context/LocationContext";
import { PurchaseProvider } from "./context/PurchaseContext";

const AppContent = () => {
  const location = useLocation();
  const isPurchaseFlow = location.pathname.includes("/purchase/");
  const isAuthFlow = location.pathname.includes("/auth/");

  // Debug bilgisi - Yönlendirmeleri izleyelim
  useEffect(() => {
    console.log("AppContent: Yol değişti", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white">
      {!isPurchaseFlow && !isAuthFlow && (
        <>
          <Header />
          <CategoryNav />
        </>
      )}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/register" element={<RegisterPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/category/:categoryId" element={<CategoryPage />} />
        <Route path="/product-detail/:id" element={<ProductDetail />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <OrdersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addresses"
          element={
            <ProtectedRoute>
              <AddressesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer/:dealerId/products"
          element={
            <ProtectedRoute>
              <DealerProductsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sepetim"
          element={
            <ProtectedRoute>
              <CartPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase/carpet-cleaning/carpet-details"
          element={
            <ProtectedRoute>
              <CarpetDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase/carpet-cleaning/address-details"
          element={
            <ProtectedRoute>
              <AddressDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase/carpet-cleaning/payment"
          element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase/carpet-cleaning/payment-success"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
};

function App() {
  // Debug bilgisi
  useEffect(() => {
    console.log("App bileşeni yüklendi");
  }, []);

  return (
    <Router>
      <LocationProvider>
        <PurchaseProvider>
          <AppContent />
        </PurchaseProvider>
      </LocationProvider>
    </Router>
  );
}

export default App;
